export const DS_RADIO_BUTTON_CLASSES = {
  Root: "ds-radio-button",
  Input: "ds-radio-button__input",
} as const;
